<template>
  <div>
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="Каскадировать цель"
      :visible.sync="show"
      width="70%"
      destroy-on-close
    >
      <el-row>
        <el-row class="users-filters filters-before-table" type="flex" style="margin-bottom: 32px;">
          <el-col :span="11">
            <el-input
              v-model="search"
              prefix-icon="el-icon-search"
              placeholder="Поиск"
              size="small"
              clearable
              @clear="searchChanged"
              v-debounce:500="searchChanged"
            >
            </el-input>
          </el-col>
        </el-row>
        <el-table
          ref="selectCardsTable"
          v-loading="loading"
          size="mini"
          empty-text="Нет карт"
          :data="cards"
          :row-key="(row) => row.id"
          @sort-change="sortChanged($event, searchCards)"
        >
          <el-table-column type="selection" reserve-selection width="55"></el-table-column>
          <el-table-column width="150" prop="id" label="ID карты"></el-table-column>
          <el-table-column width="150" prop="user.meta.tabnr" label="Табельный номер"></el-table-column>
          <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
          <el-table-column prop="year" label="Год"></el-table-column>
          <el-table-column label="Период">
            <template v-slot="scope">
              <div>
                {{
                  $companyConfiguration.card.getAvailablePeriods()[scope.row.period]
                    ? $companyConfiguration.card.getAvailablePeriods()[scope.row.period]
                    : ''
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <paginator
          style="margin-bottom: 0"
          :paginator.sync="paginator"
          @page-changed="searchCards"
        ></paginator>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">Отмена</el-button>
        <el-button
          :disabled="$refs.selectCardsTable && !$refs.selectCardsTable.selection.length"
          :loading="loading"
          type="primary"
          @click="addSelectedCards"
          size="small"
          icon="fas fa-plus"
        >
          Каскадировать на выбранных пользователей
        </el-button>
      </div>
    </el-dialog>
    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>
import {off, on} from "element-ui/src/utils/dom";
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import {sorter} from "@/mixins/sorter";
import {mapGetters} from "vuex";

export default {
  name: "cherkizovo-add-cascading-elements-dialog",
  mixins: [paginator, sorter],
  components: {Paginator},
  props: {},
  data() {
    return {
      loading: false,
      show: false,
      search: null,
      cards: [],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  computed: {
    ...mapGetters('card', {
      card: 'card',
    }),
  },
  watch: {},
  methods: {
    showModal() {
      this.search = null;
      this.paginator.page = 1;
      this.show = true;
      this.cards = [];

      this.searchCards();
    },
    searchChanged() {
      this.paginator.page = 1;
      this.searchCards();
    },
    searchCards() {
      this.cards = [];
      this.loading = true;

      this.$api.card.search({
        search: this.search,
        excludeCardIds: [this.card.id],
        [this.sorter.param]: this.sorter.sort,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
        expand: 'user, info',
      })
        .then(({data, paginator, sorter}) => {
          this.cards = data.cards;
          this.sorterFill(sorter);
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    addSelectedCards() {
      this.show = false;
      this.$emit('cards-selected', this.$refs.selectCardsTable.selection);
    },
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  }
}
</script>

<style>
  .single-select tr:hover{
    cursor: pointer;
  }
</style>